// Meet de daadwerkelijke kolompositie, ook bij full-width Kadence layouts.
(() => {
	const waves = [...document.querySelectorAll('.golven')];
	if (!waves.length) return;
	let frame;
	const update = () => {
		cancelAnimationFrame(frame);
		frame = requestAnimationFrame(() => {
			const viewport = document.documentElement.clientWidth;
			const positions = waves.map(element => ({ element, rect: element.getBoundingClientRect() }));
			positions.forEach(({ element, rect }) => {
				element.style.setProperty('--iml-golven-links-offset', `${-rect.left}px`);
				element.style.setProperty('--iml-golven-rechts-offset', `${rect.right - viewport}px`);
			});
		});
	};
	const observer = new ResizeObserver(update);
	observer.observe(document.documentElement);
	waves.forEach(element => {
		observer.observe(element);
		if (element.parentElement) observer.observe(element.parentElement);
	});
	window.addEventListener('resize', update);
	window.addEventListener('load', update);
	if (document.fonts) document.fonts.ready.then(update);
	update();
})();
